<template>
	<div class="row">
		<div class="col-12 col-lg-4 order-2 order-md-0" v-if="!isMobile">
			<user-info></user-info>
		</div>
		<div class="col-12 col-lg-8">
			<div class="block block--visible block--nopad">
				<div class="block__content">
					<transaction-table></transaction-table>
				</div>
			</div>

		</div>
	</div>

</template>
<script>
	import UserInfo from './modules/info';
	import TransactionTable from './modules/transactionTable';

	export default {
		name: 'UserTransactions',
		components: {
			UserInfo,
			TransactionTable
		},
		data() {
			return {

			}
		},

	}
</script>